import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DashboardComponent } from '@sd-portal/shared/dashboard';
import { SharedEnvironmentModule } from '@sd-portal/shared/environment';
import {
  OidcCallbackComponent,
  OidcGuard,
  PageErrorComponent,
  PageNotFoundComponent,
  PostflightStandaloneGuard,
  PostLoginComponent,
  UnauthorizedComponent
} from '@sd-portal/shared/shell';
import { TrainingVideosComponent } from '@sd-portal/training-videos';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'pre-flight/calendar' },
  { path: 'dashboard', component: DashboardComponent, canActivate: [OidcGuard] },
  {
    path: 'post-flight',
    loadChildren: () => import('@sd-portal/post-flight/routes').then(m => m.PostFlightRoutesModule),
    canActivate: [OidcGuard]
  },
  {
    path: 'pre-flight',
    loadChildren: () => import('@sd-portal/pre-flight/routes').then(m => m.PreFlightRoutesModule),
    canActivate: [OidcGuard, PostflightStandaloneGuard]
  },
  {
    path: 'profile/external-grant',
    loadChildren: () => import('@sd-portal/profile/feature-external-grant').then(m => m.ExternalGrantModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('@sd-portal/profile/routes').then(m => m.ProfileRoutesModule),
    canActivate: [OidcGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('@sd-portal/admin/routes').then(m => m.AdminRoutesModule),
    canActivate: [OidcGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('@sd-portal/reports/routes').then(m => m.ReportsRoutesModule)
  },
  {path: 'training-videos', component: TrainingVideosComponent, canActivate: [OidcGuard]},
  // OIDC routes
  { path: 'oidccallback', component: OidcCallbackComponent },
  { path: 'postlogin', component: PostLoginComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },
  // error event routes
  { path: 'error', pathMatch: 'full', component: PageErrorComponent },
  { path: '', pathMatch: 'full', redirectTo: 'dashboard' },
  { path: '**', pathMatch: 'full', component: PageNotFoundComponent }
];

@NgModule({
  imports: [SharedEnvironmentModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [PostflightStandaloneGuard, OidcGuard]
})
export class AppRoutingModule {}
